// Export/Import Panel Component
// Organized for Supabase Migration

import React from 'react';
import { Download, Upload, Eye, EyeOff, Code as CodeIcon, Settings } from 'lucide-react';

export const ExportImportPanel = ({
  currentSketch,
  exportSketch,
  fileInputRef,
  importSketch,
  showJSON,
  toggleJSON,
  showCode,
  toggleCode,
  showParameters,
  toggleParameters
}) => {
  const handleImportClick = () => {
    fileInputRef.current?.click();
  };

  const handleImportChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    importSketch(file).then(() => {
      alert('Successfully imported sketch!');
    }).catch((error) => {
      alert('Error importing sketch: ' + error.message);
    });
    
    event.target.value = '';
  };

  return (
    <div className="bg-gray-50 rounded-lg p-4 mb-4">
      <h3 className="text-lg font-semibold mb-3">Export/Import/Code</h3>
      <div className="space-y-2">
        <button
          onClick={() => currentSketch && exportSketch(currentSketch)}
          disabled={!currentSketch}
          className="w-full flex items-center justify-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
        >
          <Download className="w-4 h-4" />
          Export JSON
        </button>
        
        <input
          ref={fileInputRef}
          type="file"
          accept=".json"
          onChange={handleImportChange}
          className="hidden"
        />
        <button
          onClick={handleImportClick}
          className="w-full flex items-center justify-center gap-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors"
        >
          <Upload className="w-4 h-4" />
          Import JSON
        </button>
        
        <button
          onClick={toggleJSON}
          className={`w-full flex items-center justify-center gap-2 px-4 py-2 rounded-lg transition-colors ${
            showJSON 
              ? 'bg-orange-600 text-white hover:bg-orange-700' 
              : 'bg-orange-100 text-orange-700 hover:bg-orange-200'
          }`}
        >
          {showJSON ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
          {showJSON ? 'Hide JSON' : 'Show JSON'}
        </button>
        <button
          onClick={toggleCode}
          className={`w-full flex items-center justify-center gap-2 px-4 py-2 rounded-lg transition-colors ${
            showCode 
              ? 'bg-purple-600 text-white hover:bg-purple-700' 
              : 'bg-purple-100 text-purple-700 hover:bg-purple-200'
          }`}
        >
          <CodeIcon className="w-4 h-4" />
          {showCode ? 'Hide Code' : 'Show Code'}
        </button>
        <button
          onClick={toggleParameters}
          className={`w-full flex items-center justify-center gap-2 px-4 py-2 rounded-lg transition-colors ${
            showParameters 
              ? 'bg-indigo-600 text-white hover:bg-indigo-700' 
              : 'bg-indigo-100 text-indigo-700 hover:bg-indigo-200'
          }`}
        >
          <Settings className="w-4 h-4" />
          {showParameters ? 'Hide Parameters' : 'Edit Parameters'}
        </button>
      </div>
    </div>
  );
};
